import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const SSN_LENGTH = 9;
const formatSsn = (raw: string): string => {
  const digits = raw.replace(/\D/g, "").slice(0, SSN_LENGTH);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};

interface MaskedSsnInputProps {
  value?: string;
  onChange: (value: string) => void;
  label: string;
  required?: boolean;
  id?: string;
  className?: string;
  disabled?: boolean;
}

export function MaskedSsnInput({
  value = "",
  onChange,
  label,
  required,
  id,
  className,
  disabled,
}: MaskedSsnInputProps) {
  const display = formatSsn(value);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, SSN_LENGTH);
    onChange(raw);
  };

  return (
    <div className={cn("space-y-2", className)}>
      <Label htmlFor={id}>
        {label}
        {required && <span className="text-destructive ml-0.5">*</span>}
      </Label>
      <Input
        id={id}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        placeholder="XXX-XX-XXXX"
        value={display}
        onChange={handleChange}
        disabled={disabled}
        maxLength={11}
      />
    </div>
  );
}
